/**
 * Toast notification for submission success/error.
 * On success, copies the issue key to the clipboard automatically.
 */

let timeout: ReturnType<typeof setTimeout> | null = null;

export function showToast(shadow: ShadowRoot, type: "success" | "error", message: string): void {
  const toast = shadow.querySelector(".ip-toast") as HTMLDivElement | null;
  if (!toast) return;

  if (timeout) clearTimeout(timeout);

  toast.className = `ip-toast ${type}`;
  toast.textContent = message;

  // On success, copy the issue key to clipboard and show hint
  if (type === "success") {
    // Extract the issue key (e.g. "AEMED-123" from "Submitted: AEMED-123")
    const match = message.match(/[A-Z]+-\d+/);
    if (match) {
      const issueKey = match[0];
      navigator.clipboard?.writeText(issueKey).then(
        () => {
          toast.textContent = `\u2705 ${message} \u2014 copied to clipboard`;
        },
        () => {
          // Clipboard write failed (permissions), just show the message
        },
      );
    }
  }

  requestAnimationFrame(() => {
    toast.classList.add("visible");
  });

  timeout = setTimeout(() => {
    toast.classList.remove("visible");
  }, 5000);
}
